export default __webpack_public_path__ + "static/media/default-thumb.3ee74bb2.jpeg";